import {
  ArrowLeftStartOnRectangleIcon,
  CheckIcon,
  ChevronRightIcon,
  GlobeAltIcon,
} from '@heroicons/react/24/outline';
import { Menu, Paper, Text, UnstyledButton } from '@mantine/core';

import { projectConfigs } from '@/shared/config/projects';
import { useCurrentProject } from '@/shared/projects/project-path';
import { useGlobalStore } from '@/shared/stores/global.store';

import { useGetLanguages } from '../../model/languages.cases';

export const AdminMenu = () => {
  const { data: languagesData } = useGetLanguages();
  const project = useCurrentProject();
  const user = useGlobalStore((state) => state.sessions[project].user);
  const logout = useGlobalStore((state) => state.logout);
  const localization = useGlobalStore((state) => state.localization);
  const supportsLanguages = projectConfigs[project].capabilities.languages;

  return (
    <Paper shadow="xs">
      <Menu withArrow position="top" width={200}>
        <Menu.Target>
          <UnstyledButton
            style={{
              padding: 'var(--mantine-spacing-md)',
              color: 'var(--mantine-color-text)',
              borderRadius: 'var(--mantine-radius-sm)',
            }}
          >
            <div style={{ flex: 1 }}>
              <Text size="sm" fw={500}>
                {user.name}
              </Text>

              <Text c="dimmed" size="xs">
                {user.email}
              </Text>
            </div>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          {supportsLanguages && (
            <Menu
              width={200}
              shadow="md"
              position="right-end"
              closeOnItemClick={false}
            >
              <Menu.Target>
                <Menu.Item
                  leftSection={<GlobeAltIcon width={20} />}
                  rightSection={<ChevronRightIcon width={20} />}
                >
                  Язык
                </Menu.Item>
              </Menu.Target>

              <Menu.Dropdown>
                {languagesData.languages.map((language) => (
                  <Menu.Item
                    key={language.slug}
                    rightSection={
                      localization.currentLanguage == language.slug && (
                        <CheckIcon width={20} />
                      )
                    }
                    onClick={() =>
                      localization.setCurrentLanguage(language.slug)
                    }
                  >
                    {language.title}
                  </Menu.Item>
                ))}
              </Menu.Dropdown>
            </Menu>
          )}

          <Menu.Item
            onClick={() => logout(project)}
            leftSection={<ArrowLeftStartOnRectangleIcon width={20} />}
          >
            Выйти
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Paper>
  );
};
